import React from 'react';

const ProjectCard = ({ title, description, link }) => {
    return (
        <div className="project-card">
            <h3>{title}</h3>
            <p>{description}</p>
            <a href={link} target="_blank" rel="noopener noreferrer">Learn More</a>
        </div>
    );
};

export default ProjectCard;